import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { AuthService } from "./../../shared/models/auth.service";
import { SearchFilterModel } from "./../models/search-filter.model";
import { InstanceService } from "../../instance/models/instance.service";
import { PermissionType, RoleLevel } from "../../shared/config";
import { TranslateService } from "./../../shared/translate/translate.service";
import { CompanyService } from "../../company/models/company.service";
import { OrganizationService } from "../../organization/models/organization.service";
import { SharedVehicleGroupService } from "../../sharedvehiclegroup/models/sharedvehiclegroup.service";
import { TermsConditionModel } from "../models/terms-condition.model";

const SlimSelect = require("slim-select");

@Component({
  selector: "wego-termsandcondition-search-filter",
  template: require('../views/search-filter.component.html'),
  providers: [
    InstanceService,
    CompanyService,
    OrganizationService,
    SharedVehicleGroupService
  ]
})

export class SearchFilterComponent implements OnInit {
  tempmodel: SearchFilterModel;
  seachFilterList: SearchFilterModel[];
  model: SearchFilterModel = new SearchFilterModel();
  searchInstanceName: string;
  searchCompanyName: string;
  instanceName: string;
  searchOrganizationName: string;
  searchSVGName: string;
  roleLevel = RoleLevel;
  instanceList: any;
  companyList: any;
  svgList: any;
  organizationList: any;
  apiErrorMsg: string;
  instanceSelect: any;
  companySelect: any;
  organizationSelect: any;
  svgSelect: any;
  LblSelect: string;
  LblInstance: string;
  LblCompany: string;
  LblOrganization: string;
  LblSvg: string;
  pageName: string;
  isLoader: boolean = false;
  listOfTermsAndCondition: TermsConditionModel;
  _isReset: boolean;

  @Output("OnDetailSearch") OnDetailSearch = new EventEmitter();
  @Output("OnAdvanceReset") OnAdvanceReset = new EventEmitter();

  @Input()
  set IsResetParameter(isResetFlag: boolean) {
    this._isReset = isResetFlag;
    if (this._isReset == true) {
      this.ResetParameters();
    }
  }

  get IsResetParameter() { return this._isReset; }

  constructor(
    public authService: AuthService,
    public instanceService: InstanceService,
    private translate: TranslateService,
    public companyService: CompanyService,
    public organizationService: OrganizationService,
    public sharedVehicleGroupService: SharedVehicleGroupService
  ) { }

  ngOnInit() {
    this.listOfTermsAndCondition = new TermsConditionModel();

    this.pageName = "Terms_And_Condition";
    this.LblSelect = this.translate.instant("LblSelect");
    this.LblInstance = this.translate.instant("LblInstance");
    this.LblCompany = this.translate.instant("LblCompany");
    this.LblOrganization = this.translate.instant("LblOrganization");
    this.LblSvg = this.translate.instant("LblSharedVehicleGroup");

    this.tempmodel = this.authService.AssignFromStorage(
      this.constructor.name + "_model",
      this.tempmodel
    );

    this.GetInstanceList();

  }

  public GetInstanceList() {
    this.instanceService.GetDropdownInstanceList(this.pageName).subscribe(
      res => {
        this.instanceList = res.data;
        if (this.instanceList && this.instanceList.length > 0) {
          if (!this.model.instanceHashId && this.instanceList.length == 1) {
            this.model.instanceHashId = this.instanceList[0].keyHash;
            this.model.InstanceHashIdList = [];
            this.model.InstanceHashIdList.push(this.instanceList[0].keyHash);
            this.model.instanceHashId = this.instanceList[0].keyHash;
          }
          this.OnInstanceChange();
          // if (this.tempmodel) {
          //   this.instanceSelect.set(this.tempmodel.InstanceHashIdList);
          // }
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public OnInstanceChange() {
    this.isLoader = true;

    setTimeout(() => {
      if (this.tempmodel && this.tempmodel.InstanceHashIdList) {
        this.model.InstanceHashIdList = this.tempmodel.InstanceHashIdList;
        this.instanceSelect.set(this.tempmodel.InstanceHashIdList);
        this.tempmodel.InstanceHashIdList = null;
        this.setCompanyFilter();
      }
    }, 200);

    if (this.model.InstanceHashIdList) {

      this.OnDetailSearch.emit({
        InstanceHashIdList: this.model.InstanceHashIdList,
      });
      this.GetCompanyList();
      this.model.companyHashId = "";

    } else {
      this.companyList = [];
      this.model.companyHashId = "";
    }
  }

  public GetCompanyList() {

    if (!(this.authService.GetHighestRoleLevel()<= this.roleLevel.Instance))
    {
      this.model.InstanceHashIdList =  this.instanceList.map((x:any)=>x.keyHash);
    }

    this.companyService.GetDropdownCompanyListByInstanceIdList(this.pageName, PermissionType.VIEW, this.model.InstanceHashIdList).subscribe(
      res => {
        this.companyList = res.data;
        if (this.companyList && this.companyList.length > 0) {
          if (!this.model.companyHashId && this.companyList.length == 1) {
            this.model.companyHashId = this.companyList[0].keyHash;
            this.model.CompanyHashIdList = [];
            this.model.CompanyHashIdList.push(this.companyList[0].keyHash);
            this.model.companyHashId = this.companyList[0].keyHash;
          }
          this.OnCompanyChange();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  private setCompanyFilter() {
    setTimeout(() => {
      if (this.tempmodel && this.tempmodel.CompanyHashIdList) {
        this.model.CompanyHashIdList = this.tempmodel.CompanyHashIdList;
        this.companySelect.set(this.tempmodel.CompanyHashIdList);
        this.tempmodel.CompanyHashIdList = null;
        this.setOrganizationFilter();
      }
    }, 200);
  }

  private setOrganizationFilter() {
    setTimeout(() => {
      if (this.tempmodel && this.tempmodel.OrganizationHashIdList) {
        this.model.OrganizationHashIdList = this.tempmodel.OrganizationHashIdList;
        this.organizationSelect.set(this.tempmodel.OrganizationHashIdList);
        this.tempmodel.OrganizationHashIdList = null;
        this.setSVGFilter();
      }
    }, 200);
  }

  private setSVGFilter() {
    setTimeout(() => {
      if (this.tempmodel && this.tempmodel.SharedVehicleGroupHashIdList) {
        this.model.SharedVehicleGroupHashIdList = this.tempmodel.SharedVehicleGroupHashIdList;
        this.svgSelect.set(this.tempmodel.SharedVehicleGroupHashIdList);
        this.tempmodel.SharedVehicleGroupHashIdList = null;
      }
    }, 200);
  }

  public OnCompanyChange() {
    this.isLoader = true;

    if (this.model.CompanyHashIdList) {
      this.OnDetailSearch.emit({
        CompanyHashIdList: this.model.CompanyHashIdList,
      });
      this.GetOrganizationList();
      this.model.organizationHashId = "";
    } else {
      this.organizationList = [];
      this.model.organizationHashId = "";
    }
  }

  public OnOrganizationChange() {
    this.isLoader = true;


    if (this.model.OrganizationHashIdList) {
      this.OnDetailSearch.emit({
        OrganizationHashIdList: this.model.OrganizationHashIdList,
      });

      this.GetSVGList();
      this.model.sharedVehicleGroupHashId = "";

    } else {
      this.svgList = [];
      this.model.sharedVehicleGroupHashId = "";
    }
  }

  public GetOrganizationList() {

    if (!(this.authService.GetHighestRoleLevel()<= this.roleLevel.Company))
    {
      this.model.CompanyHashIdList =  this.companyList.map((x:any)=>x.keyHash);
    }

    this.organizationService.GetDropdownOrganizationListByCompanyIdList(this.pageName, PermissionType.VIEW, this.model.CompanyHashIdList).subscribe(
      res => {
        this.organizationList = res.data;
        if (this.organizationList && this.organizationList.length > 0) {
          if (!this.model.organizationHashId && this.organizationList.length == 1) {
            this.model.organizationHashId = this.organizationList[0].keyHash;

            this.model.OrganizationHashIdList = [];
            this.model.OrganizationHashIdList.push(
              this.organizationList[0].keyHash
            );
            this.model.organizationHashId = this.organizationList[0].keyHash;

          }
          this.OnOrganizationChange();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  onSVGChange() {
    if (this.model.SharedVehicleGroupHashIdList) {
      this.OnDetailSearch.emit({
        SharedVehicleGroupHashIdList: this.model.SharedVehicleGroupHashIdList,
      });
    }
  }

  public GetSVGList() {

    if (!(this.authService.GetHighestRoleLevel()<= this.roleLevel.Organization))
    {
      this.model.OrganizationHashIdList =  this.organizationList.map((x:any)=>x.keyHash);
    }

    this.sharedVehicleGroupService.GetDropdownSharedVehicleGroupListByCompanyIdList(this.pageName, PermissionType.VIEW, this.model.OrganizationHashIdList).subscribe(
      res => {
        this.svgList = res.data;
        if (this.svgList && this.svgList.length > 0) {
          if (!this.model.sharedVehicleGroupHashId && this.svgList.length == 1) {
            this.model.sharedVehicleGroupHashId = this.svgList[0].keyHash;
          }
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  ngAfterViewInit() {
    this.instanceSelect = new SlimSelect({
      select: "#instanceName",
      placeholder: this.LblSelect + " " + this.LblInstance,
      showSearch: false,
      onChange: (info: any) => {
        this.model.InstanceHashIdList = info.map((x: any) => x.value);
      }
    });
    this.instanceSelect.set(this.model.InstanceHashIdList);
    this.RenderCompany();
  }

  private RenderCompany() {
    this.companySelect = new SlimSelect({
      select: "#companyName",
      placeholder: this.LblSelect + " " + this.LblCompany,
      showSearch: false,
      onChange: (info: any) => {
        this.model.CompanyHashIdList = info.map((x: any) => x.value);
      }
    });
    this.companySelect.set(this.model.CompanyHashIdList);
    this.RenderOrganization()
  }

  private RenderOrganization() {
    this.organizationSelect = new SlimSelect({
      select: "#organizationName",
      placeholder: this.LblSelect + " " + this.LblOrganization,
      showSearch: false,
      onChange: (info: any) => {
        this.model.OrganizationHashIdList = info.map((x: any) => x.value);
      }
    });
    this.organizationSelect.set(this.model.OrganizationHashIdList);
    this.RenderSVg();
  }

  private RenderSVg() {
    this.svgSelect = new SlimSelect({
      select: "#svgName",
      placeholder: this.LblSelect + " " + this.LblSvg,
      showSearch: false,
      onChange: (info: any) => {
        this.model.SharedVehicleGroupHashIdList = info.map((x: any) => x.value);
      }
    });
    this.svgSelect.set(this.model.SharedVehicleGroupHashIdList);
  }

  public ResetParameters() {
    this.model.instanceHashId = '';
    this.model.InstanceHashIdList = [];
    this.instanceSelect.set(this.model.InstanceHashIdList);

    this.model.companyHashId = '';
    this.model.CompanyHashIdList = [];
    this.companySelect.set(this.model.CompanyHashIdList);

    this.model.organizationHashId = '';
    this.model.OrganizationHashIdList = [];
    this.organizationSelect.set(this.model.OrganizationHashIdList);

    this.model.sharedVehicleGroupHashId = '';
    this.model.SharedVehicleGroupHashIdList = [];
    this.svgSelect.set(this.model.SharedVehicleGroupHashIdList);

  }

  ngOnDestroy() {
    this.authService.SaveToStorage(
      this.constructor.name + "_model",
      this.model
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/termsandcondition/components/search-filter.component.ts